// The ONE place that owns the field app's store targets (same "stable public
// URL, target changes in exactly one place" convention as /signup).
//
// /get, the invite email's QR (src/app/public/email/get-app-qr.png) and the
// dormant SMS invite link all resolve through these constants — when the Play
// listing lands (#603), set PLAY_STORE_URL and /get starts routing Android
// users to it with no other change anywhere.

// GroundOps Field 1.0.0 — released on the App Store 2026-08-17.
export const APP_STORE_URL = 'https://apps.apple.com/au/app/groundops-field/id6781524777'

// Not on Google Play yet — epic #603 tracks the remaining Play work. While
// null, /get shows Android users a "coming soon" note instead of redirecting.
export const PLAY_STORE_URL: string | null = null

// What the printed/emailed QR encodes. Encoded into the checked-in QR PNGs
// (src/www/public/get-app-qr.png + src/app/public/email/get-app-qr.png) —
// regenerate both if this ever changes:
//   npx qrcode -o get-app-qr.png -w 480 -m 2 -e M "https://www.groundops.app/get"
export const GET_APP_URL = 'https://www.groundops.app/get'
